// (C) Copyright 2025 Hewlett Packard Enterprise Development LP

import { CATEGORY } from '../../../utils/constants'

const categoryArray = ['GENERAL', ...Object.values(CATEGORY)]

export const filteredCategoryArray = () => {
  const categoriesToRemove = [
    'COMMON',
    'RECOMMENDED',
    'ORIGANIZATION',
    'MANAGEMENT_AND_GOVERNANCE'
  ]
  const categoriesToDisplay = categoryArray.reduce((result, item) => {
    if (!categoriesToRemove.includes(item)) {
      result.push(item)
    }
    return result
  }, [])
  return categoriesToDisplay
}

export const filterAttributes = (t, apiCategoriesArray) => {
  return [
    {
      label: t(
        'get_started_videos_tutorials.videos_tutorial_page.vt_categories'
      ),
      name: 'categories',
      selectionType: 'select-multiple',
      values: apiCategoriesArray.map((item) => ({
        valueLabel:
          t(
            `get_started_videos_tutorials.videos_tutorial_page.categories.${item.toLowerCase()}`
          ) || item,
        valueName: item
      }))
    }
  ]
}
